<template>
  <div>
    <div class="bigBox">
    </div>
    <div style="padding: 10px;">
      <div style="text-align: left;">
        <div style="padding-top: 45px;"></div>

        <div style="text-align: center;"><img src="https://h5.qkier.cn/icons/gh_75150a09a6e8_258.jpg"></div>
        <div style="text-align: center;padding-top: 15px;">请长按识别小程序码，启动【创维轻客+】小程序</div>

      </div>
      <div style="white-space: pre-wrap;text-align: center;">
        <van-list @load="onLoad"></van-list>
      </div>
    </div>

  </div>
</template>

<script>

  function getUrlKey (name) {//获取url 参数
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  }

  export default {
    mounted () {
      let name = getUrlKey('name')//获取url参数code

    },
    data () {
      return {}
    },
    methods: {
      onLoad: function () {
        console.log('onload...')
      },

    }
  }

</script>
<style>
  .bigBox {
    margin-top: 5pt;
    height: 120pt;
    width: 100%;
    background-image: url('/static/images/img_qkier.jpg');
    background-size: cover;
    background-position: center;
  }

  .hint {
    margin-top: 20 rpx;
    text-align: center;
  }

  .greend {
    color: #46C9BA;
  }

  .red {
    color: red;
  }

  .topUpBox {
    margin-top: 40 rpx;
    width: 100%;
  }

  .topUpBoxLi {
    display: inline-block;
    width: 30%;
    height: 50pt;
    /* background-color: rgb(225, 236, 245); */
    background-color: #e8f3ff;
    margin-left: 7pt;
    margin-top: 7pt;
    border-radius: 7pt;
    text-align: center;
  }

  .topUpBoxLiP {
    color: #3298ff;
    font-size: 12pt;
    margin: 10pt 0 0 0;
  }

  .LiSpan {
    font-size: 14pt;
  }

  .topUpBoxLiSpan {
    font-size: 10pt;
    /* color: rgb(179, 179, 179); */
    color: rgb(32, 32, 32);
  }

  .topUpBoxLiIf {
    /* background-color: rgb(240, 240, 240); */
    background-color: #46C9BA;
  }

  .topUpBoxLiPIf {
    /* color:rgb(83, 83, 83) */
    color: #fff;
  }

  .topUpBoxLiSpanIf {
    color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/pages/device/devicetest.vue